import React, { useState } from "react";
import Alert from '@mui/material/Alert';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

function RefreshToken({
  user,
  loginRequest,
  loginUser,
  logoutUser,
  toggleDialog = () => {},
  disableUsername = true,
}) {
  const [open, setOpen] = useState(true);
  const [username, setUsername] = useState(user);
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState([]);

  const formIsValid = () => {
    const errors = {};
    if (!username) errors.username = "Username is required.";
    if (!password) errors.password = "Password is required.";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const logoutHandler = (event) => {
    event.preventDefault();
    logoutUser();
  };

  const keyPress = (Event) => {
    // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
    if (Event.key === "Enter") {
      Event.preventDefault();
      Event.stopPropagation();
      onSubmit(Event);
    }
  };

  const onSubmit = () => {
    if (!formIsValid()) return;

    const payload = loginRequest(username, password);
    loginUser(payload, username, password);
    setOpen(false);
    toggleDialog();
  };

  return (
    <Box m={1} width="100%" align="center">
      <Dialog open={open}>
        <DialogTitle id="refresh-token-form">Login Form</DialogTitle>
        <DialogContent>
          <Grid container justifyContent="center" alignItems="center" spacing={2}>
            <Grid item xs={12}>
              <TextField
                name="username"
                label="Username"
                variant="outlined"
                fullWidth
                InputProps={{ style: { backgroundColor: "white" } }}
                size="small"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={disableUsername}
              />
              {errors.username && <Alert severity="error">{errors.username}</Alert>}
            </Grid>
            <Grid item xs={12}>
              <TextField
                key={"password"}
                name="password"
                label="Password"
                variant="outlined"
                fullWidth
                InputProps={{ style: { backgroundColor: "white" } }}
                type="password"
                size="small"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => keyPress(e)}
              />
              {errors.password && <Alert severity="error">{errors.password}</Alert>}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container justifyContent="center" alignItems="center" className="margTop40">
            <Grid item xs="auto" className="margRight20">
              <Button variant="contained" className="warningBtn" onClick={logoutHandler}>
                Logout
              </Button>
            </Grid>
            <Grid item xs="auto" className="margRight20">
              <Button variant="contained" className="successBtn" onClick={onSubmit}>
                Log In
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default RefreshToken;
